import React, { Component } from 'react';
import { Alert, Button, FormFeedback, Card, CardBody, CardGroup, Col, Container, Form, Input, InputGroup, InputGroupAddon, InputGroupText, Row } from 'reactstrap';
import { Redirect } from 'react-router';
import cookie from 'react-cookies';
import { isEmpty } from 'lodash';

import FormValidator from '../../FormValidator/FormValidator';
import { loginValidationRules } from './validations';
import { apiBaseUrl, captchaSiteKey, admin_mode } from '../../../configs/configs';
import ReCAPTCHA from 'react-google-recaptcha';


class Login extends Component {

	constructor(props) {
		super(props);

		this.validator = new FormValidator(loginValidationRules);
		this.state = {
			data: false,
			email: '',
			password: '',
			forgotPasswordClick: false,
			serverValidationDone: false,
			validation: this.validator.valid(),
			alertClass: '',
			alertMessage: '',
			inlineLoading: false,
			captcha: false
		};

		this.submitted = false;
		this.handleSubmit = this.handleSubmit.bind(this);
		this.handleEmailChange = this.handleEmailChange.bind(this);
		this.handlePasswordChange = this.handlePasswordChange.bind(this);
		this.onForgotPasswordHandle = this.onForgotPasswordHandle.bind(this);

		this.verifyCallback = this.verifyCallback.bind(this);

	}

	state = {
		ready: false
	};
	recaptcha = React.createRef();

	componentDidMount() {
		this.setState({
			captcha: admin_mode == "live" ? false : true
		});
	}

	componentDidUpdate() {
		try {
			if (this.state.ready) {
				this.recaptcha.current.reset();
			}
		} catch (error) {

		}
	}

	async verifyCallback(recaptchaToken) {
		try {
			// console.log('12112212',recaptchaToken);
			// // Here you will get the final recaptchaToken!!!  
			// console.log(recaptchaToken, "<= your recaptcha token")
			const loginApi = `${apiBaseUrl}/verify_captcha`;
			const requestBody = { token: recaptchaToken };
			const response = await fetch(loginApi, {
				method: 'POST',
				headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json',
				},
				body: JSON.stringify(requestBody),
			});

			const res = await response.json();
			console.log("response****", response)
			console.log("res****", res)
			if (response.status === 200 && res.status && res.data.verify) {
				this.setState({
					"captcha": true,
					"displayAlert": false
				});
			} else {

				this.setState({
					displayAlert: true,
					alertClass: 'danger',
					alertMessage: 'Captcha is not verified',
					inlineLoading: false
				});

			}


		} catch (error) {

		}

	}

	handleEmailChange(event) {
		this.setState({ email: event.target.value });
	}

	handleCaptcha(event) {
		console.log('enter', event.target.value);
		// this.setState( { captcha:  event.target.value });
	}

	handlePasswordChange(event) {
		this.setState({ password: event.target.value });
	}

	handleSubmit(event) {
		try {
			event.preventDefault();

			const validation = this.validator.validate(this.state);
			this.setState({ validation });
			this.submitted = true;
			// console.log(this.state.captcha,"this.state.captcha");
			if (validation.isValid && this.state.captcha) {
			// if (validation.isValid ) {
				this.setState({ inlineLoading: true }, async () => {

					const loginApi = `${apiBaseUrl}/admin/login`;
					const requestBody = { email: this.state.email, password: this.state.password };
					const response = await fetch(loginApi, {
						method: 'POST',
						headers: {
							'Accept': 'application/json',
							'Content-Type': 'application/json',
						},
						body: JSON.stringify(requestBody),
					});

					const res = await response.json();

					if (response.status === 200 && res.token && res) {

						cookie.save('token', res.result && res.token);
						cookie.save('adminId', res.result && res.result.adminData && res.result.adminData.id);
						cookie.save('adminType', res.result && res.result.adminData && res.result.adminData.type);
						cookie.save('accessModules', res.result && res.result.adminData && res.result.adminData.accessModules);
						this.setState({ data: true, inlineLoading: false });

					} else if (response.status === 401) {

						this.setState({ displayAlert: true, alertClass: 'danger', alertMessage: 'Email/Password are not correct.', inlineLoading: false });

					} else if (response.status === 422) {
						const errors = (res.result && res.result.errors) || [];
						if (!isEmpty(errors)) {

							errors.map((error) => {

								if (this.state.validation.hasOwnProperty(error.param) === true) {

									let validationClone = Object.assign({}, this.state.validation);
									validationClone.isValid = false;
									validationClone[error.param].isInvalid = true;
									validationClone[error.param].message = error.msg;

									this.setState({ validation: validationClone, serverValidationDone: true, inlineLoading: false });

								}

							});

						} else {

							this.setState({ displayAlert: true, alertClass: 'danger', alertMessage: res.msg, inlineLoading: false });

						}


					} else {

						this.setState({ displayAlert: true, alertClass: 'danger', alertMessage: res.msg || 'Something went wrong.', inlineLoading: false });

					}

				});

			} else if (this.state.captcha === false) {
				this.setState({
					displayAlert: true,
					alertClass: 'danger',
					alertMessage: 'Please verify the captcha',
					inlineLoading: false
				});
			}
		} catch (error) {
			console.log("error", error)
		}
	}

	onForgotPasswordHandle() {
		this.setState({ forgotPasswordClick: true });
	}

	inlineLoading() {

		if (this.state.inlineLoading) {

			return <i className="fa fa-spinner fa-spin" ></i>

		}

	}

	render() {
		let validation = this.submitted && (this.state.serverValidationDone === false) ?
			this.validator.validate(this.state) :
			this.state.validation
		if (this.state.data) {
			return <Redirect to='/contests_schedule' />
		}
		if (this.state.forgotPasswordClick) {
			return <Redirect to='/password/forgot' />
		}
		return (
			<div className="app flex-row align-items-center">
				<Container>
					<Row className="justify-content-center">
						<Col md="8">
							<CardGroup>
								<Card className="p-4">
									<CardBody>

										<Form onSubmit={this.handleSubmit}>
											<h1>Login</h1>
											<p className="text-muted">Sign In to your account</p>
											{this.state.displayAlert === true ? <div><Alert color={this.state.alertClass}>
												{this.state.alertMessage}
											</Alert></div> : null}
											{admin_mode == "live" ?
												<InputGroup className="mb-3">
													<div>
														<ReCAPTCHA
															ref={this.recaptcha}
															sitekey={captchaSiteKey}

															onLoad={() => {
																this.setState({ ready: true });
															}}
															name="recaptcha"
															onChange={this.verifyCallback.bind(this)}
														/>
													</div>
												</InputGroup>
												:
												""
											}

											<InputGroup className="mb-3">
												<InputGroupAddon addonType="prepend">
													<InputGroupText>
														<i className="icon-user"></i>
													</InputGroupText>
												</InputGroupAddon>
												<Input onChange={this.handleEmailChange} invalid={validation.email.isInvalid} type="text" placeholder="Email" name="email" autoComplete="email" />
												<FormFeedback>{validation.email.message}</FormFeedback>
											</InputGroup>
											<InputGroup className="mb-4">
												<InputGroupAddon addonType="prepend">
													<InputGroupText>
														<i className="icon-lock"></i>
													</InputGroupText>
												</InputGroupAddon>
												<Input onChange={this.handlePasswordChange} invalid={validation.password.isInvalid} type="password" placeholder="Password" name="password" autoComplete="current-password" />
												<FormFeedback>{validation.password.message}</FormFeedback>
											</InputGroup>
											<Row>
												<Col xs="6">
													<Button color="primary" className="px-4">Login {this.inlineLoading()}</Button>
												</Col>
												<Col xs="6" className="text-right">
													<Button color="link" className="px-0" onClick={this.onForgotPasswordHandle}>Forgot password?</Button>
												</Col>
											</Row>
										</Form>
									</CardBody>
								</Card>
								<Card className="text-white bg-primary py-5 d-md-down-none" style={{ width: 44 + '%' }}>
									<CardBody className="text-center">
										<div>
											<h2>GameEx Sports</h2>
										</div>
									</CardBody>
								</Card>
							</CardGroup>
						</Col>
					</Row>
				</Container>
			</div>
		);
	}
}

export default Login;
